var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 24,
    viewBox: "0 0 12 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.89 0.173003V3.98H9.729C9.6455 3.96841 9.5613 3.96273 9.477 3.963C8.97624 3.96368 8.4947 4.15579 8.131 4.5C7.85652 4.90767 7.71121 5.38856 7.714 5.88C7.71282 5.94175 7.71516 6.00352 7.721 6.065V8.782H11.756L11.222 13.051H7.727V24H3.512V13.05H0V8.782H3.512V5.638C3.505 5.538 3.502 5.416 3.502 5.296C3.49498 3.8885 4.00898 2.52818 4.945 1.477C5.88973 0.532767 7.1703 0.00162407 8.506 2.7221e-06C8.592 2.7221e-06 8.678 2.72226e-06 8.764 0.00700272H8.751C8.864 2.72226e-06 9 2.7221e-06 9.128 2.7221e-06C10.0884 -0.000475248 11.0478 0.061992 12 0.187003L11.889 0.175003L11.89 0.173003Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.feea3df3949e69c7675a593e730ee24f.svg";
export { ForwardRef as ReactComponent };